export { default } from './FatalError';
